package org.example.project.ui.theme

import androidx.compose.ui.graphics.Color

/**
 * Editorial Web Panel Theme Tokens aligned with Playful Studio design system.
 */
object EditorColors {
    // Canvas & backgrounds
    val Background = Color(0xFFFFF9F2)       // Warm playful background
    val Surface = Color(0xFFFFFFFF)          // Pure White cards & surfaces
    val SurfaceSubtle = Color(0xFFF5EFE8)    // Warm neutral second-plane
    val SurfaceHover = Color(0xFFEDE4DB)     // Warm hover state

    // Borders
    val Border = Color(0xFFE4DCD4)           // Subtle border
    val BorderSubtle = Color(0xFFF0EAE3)     // Very light border
    val BorderStrong = Color(0xFFCBD5E1)     // Strong border for controls

    // Text & Content
    val TextPrimary = Color(0xFF26344A)      // Deep slate text
    val TextSecondary = Color(0xFF5E6879)    // Supporting metadata text
    val TextMuted = Color(0xFF8A94A6)        // Muted captions & hints
    val TextDisabled = Color(0xFFB0B7C3)     // Disabled state

    // Brand & Primary (Playful Coral)
    val Primary = Color(0xFFE96F55)          // Playful Coral
    val PrimaryHover = Color(0xFFD6583E)     // Coral dark
    val PrimarySubtle = Color(0xFFFDF0ED)    // Coral tinted background
    val PrimaryBorder = Color(0xFFF9CEBA)    // Coral light border
    val PrimaryDark = Color(0xFF26344A)      // Deep primary dark

    // Accents
    val AccentTeal = Color(0xFF3EA995)
    val AccentTealLight = Color(0xFFEBF7F5)
    val AccentTealBorder = Color(0xFFBCE6DE)

    val AccentLilac = Color(0xFF9381D0)
    val AccentLilacLight = Color(0xFFF4F1FA)
    val AccentLilacBorder = Color(0xFFD6CFF0)

    val AccentYellow = Color(0xFFF2C75C)
    val AccentYellowLight = Color(0xFFFEF9EB)
    val AccentYellowBorder = Color(0xFFFDE6A5)

    // Status Draft (Amber / Yellow)
    val DraftBg = Color(0xFFFEF9EB)          // Amber/Yellow tinted
    val DraftText = Color(0xFF8A6805)        // Warm amber dark
    val DraftBorder = Color(0xFFFDE6A5)      // Amber border

    // Status Published / Success (Green / Emerald)
    val SuccessBg = Color(0xFFE8F5E9)        // Emerald tinted
    val SuccessText = Color(0xFF1B5E20)      // Emerald dark
    val SuccessBorder = Color(0xFFA5D6A7)    // Emerald border
    val SuccessSolid = Color(0xFF2E7D32)     // Emerald solid

    // Error / Destructive (Red / Coral)
    val ErrorBg = Color(0xFFFFEBEE)          // Red tinted
    val ErrorText = Color(0xFFB71C1C)        // Red dark
    val ErrorBorder = Color(0xFFFFCDD2)      // Red border
    val ErrorSolid = Color(0xFFD32F2F)       // Red solid

    // Warning (Orange / Amber)
    val WarningBg = Color(0xFFFFF3E0)        // Orange tinted
    val WarningText = Color(0xFFBF360C)      // Orange dark
    val WarningBorder = Color(0xFFFFE0B2)    // Orange border
}
